import React, { useState, useEffect } from 'react';
import { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import PropTypes from 'prop-types';

import { updateColumnSizing } from '../../../actions/column';
import * as Styled from './styles';

const MIN_DISTANCE = 17;
const PIXEL_WIDTH_MULTIPLIER = 6; // blocks are 600px wide, rc-slider goes to 100.

// converts the block's column sizes into a handle value array for rc-slider
const getRangeValues = (columnSizing) => {
    const range = [];
    const columnCount = columnSizing.length;
    for (let i = 0; i < columnCount - 1; i++) {
        const previousValue = range[i - 1] || 0;
        const rangeValue = previousValue + columnSizing[i];
        range.push(rangeValue);
    }
    return range;
};

// converts rc-slider's value array into an array of the updated column sizes
const getPixelSizing = (sliderValues) => {
    const borderArray = [0, ...sliderValues, 100];
    const pixelSizing = [];
    for (let i = 0; i <= sliderValues.length; i++) {
        const nextValue = borderArray[i + 1];
        if (nextValue) {
            pixelSizing.push(Math.round(nextValue - borderArray[i]) * PIXEL_WIDTH_MULTIPLIER);
        }
    }
    return pixelSizing;
};

const ColumnWidthControls = ({ dispatch, blockID, columnSizing, disabled }) => {
    const [values, setValues] = useState([]);
    const [pixelSizes, setPixelSizes] = useState([]);

    useEffect(() => {
        const rangeValues = getRangeValues(columnSizing);
        const pixelValues = getPixelSizing(rangeValues);
        setPixelSizes(pixelValues);
        setValues(rangeValues);
    }, [columnSizing]);

    const handleChange = (newValues) => {
        const firstValue = newValues[0];
        const lastValue = newValues[newValues.length - 1];
        if (firstValue < MIN_DISTANCE || lastValue + MIN_DISTANCE > 100) {
            return;
        }
        const pixelValues = getPixelSizing(newValues);
        setPixelSizes(pixelValues);
        setValues(newValues);
    };

    const dispatchSize = () => {
        dispatch(updateColumnSizing({ newValue: values, blockID }));
    };

    return (
        <Styled.ColumnWidthControlsContainer>
            <Range
                disabled={disabled}
                defaultValue={values}
                onChange={handleChange}
                onAfterChange={dispatchSize}
                pushable={MIN_DISTANCE}
                value={values}
                trackStyle={[
                    { backgroundColor: '#0077BD', height: 3 },
                    { backgroundColor: '#0077BD', height: 3 },
                    { backgroundColor: '#0077BD', height: 3 },
                    { backgroundColor: '#0077BD', height: 3 },
                ]}
                railStyle={{ backgroundColor: '#0077BD', height: 3 }}
            />
            <div style={{ display: 'flex' }}>
                {pixelSizes.map((size, index) => (
                    <div
                        // eslint-disable-next-line react/no-array-index-key
                        key={`size-key-${index}`}
                        style={{ fontSize: 12, width: `${size / 6}%`, textAlign: 'center' }}
                    >
                        {`${size}px`}
                    </div>
                ))}
            </div>
        </Styled.ColumnWidthControlsContainer>
    );
};

ColumnWidthControls.propTypes = {
    columnSizing: PropTypes.arrayOf(PropTypes.number).isRequired,
    disabled: PropTypes.bool.isRequired,
    dispatch: PropTypes.func.isRequired,
    blockID: PropTypes.string.isRequired,
};

export default ColumnWidthControls;
